import React, { useState } from 'react';

import { Button } from 'antd';

import SignaturePad from 'react-signature-canvas';

import { dataURItoArrayBuffer } from '../../../shared/utils';

const canvasSignature = ({ rootContainer, setBytesToSave }) => {
  const [sigPad, setSigPad] = useState();

  const clear = () => {
    sigPad.clear();
    setBytesToSave(undefined);
  };

  const onSignaturePadEnd = () => {
    const dataUrl = sigPad.getTrimmedCanvas().toDataURL('image/png');
    const bytes = dataURItoArrayBuffer(dataUrl);
    setBytesToSave(bytes);
  };

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <div style={{ width: '100%', height: '100%', border: 'dashed', margin: '0 0 10px 0' }}>
        <SignaturePad canvasProps={{ width: '570px', className: 'sigCanvas' }} ref={setSigPad} onEnd={onSignaturePadEnd} />
      </div>

      <Button onClick={clear} style={{ width: '100%' }}>
        Clear
      </Button>
    </div>
  );
};

export default canvasSignature;
